import {
	RESET_PATCH_MENU,
	PRE_DEPLOY_PATCH_MENU,
	DEPLOY_PATCH_MENU,
	PRE_RESET_PATCH_MENU,
	LAST_PATCH_MENUS_GET,
	LAST_PATCH_MENUS_SUCCESS,
	LAST_PATCH_MENUS_BY_CHILD_GET,
	LAST_PATCH_MENUS_BY_CHILD_SUCCESS,
	PATCH_MENU_CONTENT_GET,
	PATCH_MENU_CONTENT_SUCCESS,
	MERGE_RULES_CHILDREN_GET,
	MERGE_RULES_CHILDREN_SUCCESS,
	MERGE_RULE_UPDATE,
	CASH_PERMISSIONS_GET,
	CASH_PERMISSIONS_SUCCESS,
	CASH_PERMISSION_UPDATE,
	MERGE_CONFIG_COPY,
	CASH_RESTRICTIONS_COPY,
	CONFIG_LOG_GET,
	CONFIG_LOG_SUCCESS,
	STASH_LIST_GET,
	STASH_LIST_SUCCESS,
	STASH_UNAVAILABLE,
	STASH_CREATE,
	STASH_RESTORE,
	STASH_DELETE,
	STASH_CONTENT_GET,
	STASH_CONTENT_SUCCESS,
	STASH_CONTENT_EXPORT,
	PATCH_MENU_CONTENT_EXPORT,
	PATCH_DATE_UPDATE,
	PATCH_CANCEL,
	CHILD_REFS_ANALYSE,
	CHILD_REFS_SUCCESS,
	CHILD_REFS_IMPORT,
	CHILDREN_RESET,
	CHILDREN_RESET_SUCCESS,
	PLACE_SEND_MAPPING_GET,
	PLACE_SEND_MAPPING_SUCCESS,
	PLACE_SEND_MAPPING_SET,
	PLACE_SEND_MAPPING_DELETE,
} from '../constants/patchMenu';
import {
	call,
	put,
	take,
	takeLatest,
	takeEvery,
	actionChannel,
	all,
	select,
} from 'redux-saga/effects';
import { requestHandler } from './fetcher.saga';
import { exportChanges } from '../utils/changesExport';
import { toFileNameFragment } from '../utils/xlsxDownload';
import {
	getRestaurantName,
	getServiceLang,
} from '../selectors/global.selector';
import { getMenuSelected, fetchAll } from './login';
import { buffers } from 'redux-saga';
import { ADD_NOTIFICATION, TAGS } from '../constants/notification';
import moment from 'moment';
import { I18n } from 'react-redux-i18n';
import { browserHistory } from 'react-router';

const PRE_REQUEST_RESET_PATCH_MENU = 'PRE_REQUEST_RESET_PATCH_MENU';
const PRE_REQUEST_DEPLOY_PATCH_MENU = 'PRE_REQUEST_DEPLOY_PATCH_MENU';

const REQUEST_RESET_PATCH_MENU_FINISHED = 'REQUEST_RESET_PATCH_MENU_FINISHED';
const REQUESTS_DEPLOY_PATCH_MENU_FINISHED =
	'REQUESTS_DEPLOY_PATCH_MENU_FINISHED';

const ENTITY = 'patchMenu';
const PATCH_METHOD = 'PATCH';
const POST_METHOD = 'POST';

///////////////////////
// DERNIERS PATCHS   //
///////////////////////
// Liste de consultation seule (onglet Déploiement, mode child/standalone) :
// aucun effet de bord, d'où un simple takeLatest plutôt que le pattern
// pre-request/finished des actions qui écrivent.
function* fetchLastPatchMenus(action) {
	const offset = (action && action.offset) || 0;
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/lastPatches',
		offset ? { offset } : {}
	);
	const payload = result && result.result ? result.result : {};
	yield put({
		type: LAST_PATCH_MENUS_SUCCESS,
		offset,
		patches: Array.isArray(payload.patches) ? payload.patches : [],
		hasMore: !!payload.hasMore,
	});
}

export function* watchGetLastPatchMenus() {
	yield takeLatest(LAST_PATCH_MENUS_GET, fetchLastPatchMenus);
}

// Vue agrégée du master : une ligne par établissement. Le serveur interroge
// une base par fils, c'est donc l'appel le plus lent de cet écran — d'où le
// chargement à la demande, seulement quand on ouvre l'onglet.
function* fetchLastPatchMenusByChild(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/lastPatchesChildren',
		{ id_menu: action.id_menu }
	);
	yield put({
		type: LAST_PATCH_MENUS_BY_CHILD_SUCCESS,
		children: result && Array.isArray(result.result) ? result.result : [],
	});
}

export function* watchGetLastPatchMenusByChild() {
	yield takeLatest(LAST_PATCH_MENUS_BY_CHILD_GET, fetchLastPatchMenusByChild);
}

// Contenu brut d'un patch. takeEvery et non takeLatest : plusieurs patchs
// peuvent être dépliés en parallèle, une requête ne doit pas en annuler une
// autre portant sur un patch différent.
function* fetchPatchMenuContent(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/patchContent',
		action.id_company
			? {
					id_patch_menu: action.id_patch_menu,
					id_company: action.id_company,
			  }
			: { id_patch_menu: action.id_patch_menu }
	);
	const payload = result && result.result ? result.result : {};
	yield put({
		type: PATCH_MENU_CONTENT_SUCCESS,
		key: action.key,
		rows: Array.isArray(payload.rows) ? payload.rows : [],
		total: payload.total || 0,
		limit: payload.limit || 0,
	});
}

export function* watchGetPatchMenuContent() {
	yield takeEvery(PATCH_MENU_CONTENT_GET, fetchPatchMenuContent);
}

// Règles de synchronisation de chaque établissement. Une base interrogée par
// fils, donc chargement à la demande, à l'ouverture de la modale seulement.
function* fetchMergeRulesChildren() {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/mergeRulesChildren',
		{}
	);
	const payload = result && result.result ? result.result : {};
	yield put({
		type: MERGE_RULES_CHILDREN_SUCCESS,
		master: payload.master || {},
		masterPermissions: Array.isArray(payload.masterPermissions)
			? payload.masterPermissions
			: [],
		children: Array.isArray(payload.children) ? payload.children : [],
	});
}

export function* watchGetMergeRulesChildren() {
	yield takeLatest(MERGE_RULES_CHILDREN_GET, fetchMergeRulesChildren);
}

// Modification d'une règle.
//
// Deux issues selon la cible. Une règle du fils modifiée depuis le siège ne
// change rien à la session en cours — on se contente de recharger les règles
// du parc pour que la modale et la comparaison se mettent à jour. En
// revanche, modifier la base courante change ce que l'écran a le droit
// d'afficher et de modifier : là, on recharge la page, comme le fait déjà le
// changement de zone ou d'établissement.
// Passer une règle en SIEGE, c'est accepter que la valeur du siège écrase
// celle de l'établissement au prochain déploiement. Le travail en cours sur ce
// champ serait perdu sans prévenir : on le met de côté d'abord, sous un nom
// qui dit pourquoi.
//
// La règle peut porter sur la base courante ou sur celle d'un fils choisi
// depuis le siège : la mise de côté suit la même cible, le serveur résolvant
// la base et la journée de travail de l'établissement visé.
function* autoStashBeforeSiege(action) {
	if (!action.toSiege) {
		return;
	}

	const id_menu = yield call(getMenuSelected);
	if (!id_menu) {
		return;
	}

	// Base sans table tampon : la mise de côté n'existe pas ici, inutile de
	// la tenter à chaque passage en SIEGE pour signaler le même échec.
	const store = yield select();
	if (store.stash && store.stash.available === false) {
		return;
	}

	// Heure comprise : plusieurs passages en SIEGE dans la même journée
	// produiraient sinon des stashes impossibles à distinguer.
	const name = I18n.t('stash.autoName', {
		date: moment().format('DD/MM/YYYY HH:mm'),
	});
	// Le serveur répond skipped s'il n'y a rien en cours : c'est lui qui
	// tranche, l'état du store pouvant dater de l'ouverture de l'écran — et,
	// pour un fils, ne rien savoir de ses modifications.
	const result = yield call(requestStash, id_menu, name, action.id_company);

	if (result === false) {
		// Signalé une fois, puis la fonctionnalité se retire : l'échec suivant
		// n'apprendrait rien de plus.
		yield put({ type: STASH_UNAVAILABLE });
		yield call(notifyError, 'stash.createFail');
		return;
	}
	if (result.skipped) {
		return;
	}

	// Le nom de l'établissement plutôt que son identifiant : la notification
	// arrive alors qu'on vient de le choisir dans le sélecteur.
	const child = action.id_company
		? (store.entity.children || []).find(
				c => String(c.id) === String(action.id_company)
			)
		: null;

	yield put({
		type: ADD_NOTIFICATION,
		notification: {
			tags: [TAGS.SUCCESS],
			text: child
				? I18n.t('stash.autoCreatedChild', { name, company: child.name })
				: I18n.t('stash.autoCreated', { name }),
			date: moment().format('DD/MM/YYYY HH:mm'),
			viewed: false,
		},
	});
}

function* updateMergeRule(action) {
	// Avant l'écriture : modifier la règle recharge la page, plus rien ne
	// s'exécuterait après.
	yield call(autoStashBeforeSiege, action);

	// La règle choisie, puis celles qui l'accompagnent : une écriture par
	// règle, un seul rechargement à la fin.
	const rules = [
		{
			type: action.ruleType,
			field: action.field,
			value: action.value,
			junction: action.junction,
		},
		...(action.extraRules || []),
	];
	// Une écriture réussie suffit à rafraîchir : l'écran doit refléter ce
	// qui a été posé, même si une règle suivante a échoué.
	let written = false;
	for (const rule of rules) {
		const { result } = yield call(
			requestHandler,
			ENTITY,
			POST_METHOD,
			true,
			{ id_company: action.id_company, ...rule },
			'/mergeRule',
			{}
		);
		if (!(result && result.result)) break;
		written = true;
	}
	if (written) {
		if (action.id_company) {
			yield put({ type: MERGE_RULES_CHILDREN_GET });
		} else {
			window.location.reload();
		}
	}
}

function* fetchCashPermissions() {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/cashPermissions',
		{}
	);
	const payload = result && result.result ? result.result : {};
	yield put({
		type: CASH_PERMISSIONS_SUCCESS,
		permissions: Array.isArray(payload.permissions) ? payload.permissions : [],
	});
}

// Après écriture, on relit plutôt que de supposer : la permission est posée
// sur tous les groupes actifs, l'état réel vient de la base.
function* updateCashPermission(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		POST_METHOD,
		true,
		{
			id_permission: action.id_permission,
			active: action.active,
			id_company: action.id_company,
		},
		'/cashPermission',
		{}
	);
	if (result && result.result) {
		if (action.id_company) {
			yield put({ type: MERGE_RULES_CHILDREN_GET });
		} else {
			yield put({ type: CASH_PERMISSIONS_GET });
		}
	}
}

// Copie des règles vers d'autres établissements. On relit le parc ensuite :
// plusieurs bases viennent de changer, et c'est la comparaison entre
// établissements qui doit refléter le nouvel état.
function* copyMergeConfig(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		POST_METHOD,
		true,
		{ id_source: action.id_source, id_targets: action.id_targets },
		'/copyMergeConfig',
		{}
	);
	if (result && result.result) {
		yield put({ type: MERGE_RULES_CHILDREN_GET });
	}
}

export function* watchCopyMergeConfig() {
	yield takeLatest(MERGE_CONFIG_COPY, copyMergeConfig);
}

function* copyCashRestrictions(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		POST_METHOD,
		true,
		{ id_source: action.id_source, id_targets: action.id_targets },
		'/copyCashRestrictions',
		{}
	);
	if (result && result.result) {
		yield put({ type: MERGE_RULES_CHILDREN_GET });
	}
}

// L'historique dépend de l'établissement choisi : takeLatest suffit, une
// sélection plus récente rend la précédente sans intérêt.
function* fetchConfigLog(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/configLog',
		action.id_company ? { id_company: action.id_company } : {}
	);
	const payload = result && result.result ? result.result : {};
	yield put({
		type: CONFIG_LOG_SUCCESS,
		key: action.id_company ? String(action.id_company) : 'master',
		entries: Array.isArray(payload.entries) ? payload.entries : [],
	});
}

export function* watchGetConfigLog() {
	yield takeLatest(CONFIG_LOG_GET, fetchConfigLog);
}

/////////////////////////////////////////
// CORRESPONDANCE POINTS DE FABRICATION //
/////////////////////////////////////////
// Siège ↔ établissement. La table vit dans la base du siège ; le serveur
// lit les points de l'établissement dans la sienne.
const PLACE_SEND_MAPPING_ROUTE = '/mapping';

function* fetchPlaceSendMapping(action) {
	const { result } = yield call(
		requestHandler,
		'placeSend',
		'GET',
		true,
		null,
		PLACE_SEND_MAPPING_ROUTE,
		{ id_company: action.id_company }
	);
	const payload = result && result.result ? result.result : {};
	yield put({
		type: PLACE_SEND_MAPPING_SUCCESS,
		key: String(action.id_company),
		mapping: {
			master: Array.isArray(payload.master) ? payload.master : [],
			child: Array.isArray(payload.child) ? payload.child : [],
			mappings: Array.isArray(payload.mappings) ? payload.mappings : [],
		},
	});
}

// Après écriture, on relit plutôt que de supposer.
function* writePlaceSendMapping(action) {
	const isDelete = action.type === PLACE_SEND_MAPPING_DELETE;
	const { result } = yield call(
		requestHandler,
		'placeSend',
		isDelete ? 'DELETE' : POST_METHOD,
		true,
		isDelete
			? {
					id_company: action.id_company,
					id_place_send_master: action.id_place_send_master,
			  }
			: {
					id_company: action.id_company,
					id_place_send_master: action.id_place_send_master,
					id_place_send_child: action.id_place_send_child,
			  },
		PLACE_SEND_MAPPING_ROUTE
	);
	if (result && result.result) {
		yield put({ type: PLACE_SEND_MAPPING_GET, id_company: action.id_company });
	} else {
		yield call(notifyError, 'mergeRules.placeSendMapping.saveFail');
	}
}

export function* watchGetPlaceSendMapping() {
	yield takeLatest(PLACE_SEND_MAPPING_GET, fetchPlaceSendMapping);
}

// takeEvery : deux lignes modifiées coup sur coup sont deux écritures
// distinctes, la seconde ne doit pas annuler la première.
export function* watchWritePlaceSendMapping() {
	yield takeEvery(
		[PLACE_SEND_MAPPING_SET, PLACE_SEND_MAPPING_DELETE],
		writePlaceSendMapping
	);
}

export function* watchCopyCashRestrictions() {
	yield takeLatest(CASH_RESTRICTIONS_COPY, copyCashRestrictions);
}

export function* watchUpdateCashPermission() {
	yield takeEvery(CASH_PERMISSION_UPDATE, updateCashPermission);
}

export function* watchGetCashPermissions() {
	yield takeLatest(CASH_PERMISSIONS_GET, fetchCashPermissions);
}

export function* watchUpdateMergeRule() {
	yield takeLatest(MERGE_RULE_UPDATE, updateMergeRule);
}

///////////
// STASH //
///////////
// Les trois écritures partagent une route, la méthode HTTP porte l'intention.
// Créer et reprendre touchent aux tables draft : elles rechargent la carte,
// comme le fait la remise à zéro. Supprimer ne touche que la table tampon.
const STASH_ROUTE = '/stash';

// Notification d'échec, partagée par les écritures de stash et les exports.
function* notifyError(key) {
	yield put({
		type: ADD_NOTIFICATION,
		notification: {
			tags: [TAGS.ERROR],
			text: I18n.t(key),
			date: moment().format('DD/MM/YYYY HH:mm'),
			viewed: false,
			openable: false,
		},
	});
}

function* fetchStashes(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		STASH_ROUTE,
		{ id_menu: action.id_menu }
	);

	// La table tampon n'est pas créée par l'application. Là où elle manque, la
	// lecture échoue : plutôt qu'une liste vide et des boutons inertes, on
	// retire la mise de côté de l'écran.
	if (result === false) {
		yield put({ type: STASH_UNAVAILABLE });
		return;
	}

	yield put({
		type: STASH_LIST_SUCCESS,
		stashes: Array.isArray(result.result) ? result.result : [],
	});
}

// Renvoie la charge utile du serveur, ou false en cas d'échec. Le serveur
// répond { skipped: true } quand la carte ne porte aucune modification : ce
// n'est pas un échec, il n'y avait rien à mettre de côté.
function* requestStash(id_menu, name, id_company, extra) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		POST_METHOD,
		true,
		{
			...(id_company ? { id_menu, name, id_company } : { id_menu, name }),
			...extra,
		},
		STASH_ROUTE
	);
	if (result === false) {
		return false;
	}
	return result.result || {};
}

// Mise de côté manuelle d'un compte master : le serveur sauvegarde la carte
// déployée avant de mettre de côté. La première, depuis le siège, est en plus
// précédée d'un déploiement sur le master seul, pour que ses tables sources
// soient à jour. C'est le serveur qui sait si c'est la première ; le front ne
// fait que dire que le geste s'y prête. La mise de côté automatique avant un
// passage en SIEGE n'est pas concernée : elle ne passe pas par ici.
function* masterSyncParams() {
	const store = yield select();
	if (!store.user.master) {
		return {};
	}
	const onSiege =
		!window.sessionStorage.master_mono_child && !window.sessionStorage.id_zone;
	if (!onSiege) {
		return { master_backup: true };
	}
	return {
		master_backup: true,
		master_sync: true,
		master_sync_name: I18n.t('stash.masterSyncName', {
			date: moment().format('DD/MM/YYYY HH:mm'),
		}),
		// Même jeton que le déploiement classique : le serveur s'en sert pour
		// notifier les caisses.
		refresh_token: window.localStorage.refresh_token,
	};
}

function* createStash(action) {
	const extra = yield call(masterSyncParams);
	const result = yield call(
		requestStash,
		action.id_menu,
		action.name,
		null,
		extra
	);

	if (result === false) {
		yield call(notifyError, 'stash.createFail');
		// La liste est rechargée même en échec : elle remet busy à false et
		// resynchronise l'affichage sur ce que le serveur a réellement fait.
		yield call(fetchStashes, action);
		return;
	}

	yield call(fetchAll);
	yield put({ type: 'REFRESH_DAY_CHANGES' });
	yield call(fetchStashes, action);

	if (result.masterSynced) {
		yield put({
			type: ADD_NOTIFICATION,
			notification: {
				tags: [TAGS.SUCCESS],
				text: I18n.t('stash.masterSynced'),
				date: moment().format('DD/MM/YYYY HH:mm'),
				viewed: false,
			},
		});
	}

	if (result.skipped) {
		return;
	}

	yield put({
		type: ADD_NOTIFICATION,
		notification: {
			tags: [TAGS.SUCCESS],
			text: I18n.t('stash.createSuccess', { name: action.name }),
			date: moment().format('DD/MM/YYYY HH:mm'),
			viewed: false,
		},
	});
}

function* restoreStash(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		PATCH_METHOD,
		true,
		{ id_menu: action.id_menu, id: action.id },
		STASH_ROUTE
	);

	if (result === false) {
		yield call(notifyError, 'stash.restoreFail');
		// La liste est rechargée même en échec : elle remet busy à false et
		// resynchronise l'affichage sur ce que le serveur a réellement fait.
		yield call(fetchStashes, action);
		return;
	}

	yield call(fetchAll);
	yield put({ type: 'REFRESH_DAY_CHANGES' });
	yield call(fetchStashes, action);

	yield put({
		type: ADD_NOTIFICATION,
		notification: {
			tags: [TAGS.SUCCESS],
			text: I18n.t('stash.restoreSuccess'),
			date: moment().format('DD/MM/YYYY HH:mm'),
			viewed: false,
		},
	});
}

function* deleteStash(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'DELETE',
		true,
		{ id_menu: action.id_menu, id: action.id },
		STASH_ROUTE
	);

	if (result === false) {
		yield call(notifyError, 'stash.deleteFail');
		// La liste est rechargée même en échec : elle remet busy à false et
		// resynchronise l'affichage sur ce que le serveur a réellement fait.
		yield call(fetchStashes, action);
		return;
	}

	yield call(fetchStashes, action);
}

// Détail d'un stash. takeEvery comme pour le contenu d'un patch : plusieurs
// stashes peuvent être dépliés, une requête ne doit pas en annuler une autre.
function* fetchStashContent(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/stashContent',
		{ id_menu: action.id_menu, id: action.id }
	);
	const payload = result && result.result ? result.result : {};
	yield put({
		type: STASH_CONTENT_SUCCESS,
		id: action.id,
		rows: Array.isArray(payload.rows) ? payload.rows : [],
		total: payload.total || 0,
		limit: payload.limit || 0,
	});
}

export function* watchGetStashes() {
	yield takeLatest(STASH_LIST_GET, fetchStashes);
}

export function* watchGetStashContent() {
	yield takeEvery(STASH_CONTENT_GET, fetchStashContent);
}

//////////////
//  EXPORT  //
//////////////
// Les descriptions sont calculées côté client, avec l'utilitaire qui alimente
// déjà l'affichage : les traduire côté serveur dupliquerait cette logique, et
// le fichier pourrait alors dire autre chose que l'écran.
//
// full: 1 lève le plafond de dix lignes de l'affichage. C'est donc une requête
// à part, jamais servie par le cache.
function* exportContent(route, params, label, withZone) {
	const { result } = yield call(requestHandler, ENTITY, 'GET', true, null, route, {
		...params,
		full: 1,
	});

	const payload = result && result.result ? result.result : null;
	const rows = payload && Array.isArray(payload.rows) ? payload.rows : [];

	if (!payload || !rows.length) {
		yield call(notifyError, 'deploy.history.exportFail');
		return;
	}

	const store = yield select();
	const entity = store.entity || {};

	yield call(exportChanges, {
		rows,
		// patch_menu_content ne porte pas la zone : la colonne ne concerne que
		// les exports issus de draft_synchro, et seulement en multi-zones.
		showZone: !!(withZone && (entity.zone || []).length),
		// Mêmes entités que la vue : celles du compte connecté. Un patch lu
		// depuis un fils retombera sur l'identifiant brut pour ce qui lui est
		// propre, exactement comme à l'écran.
		entities: {
			products: (entity.product && entity.product.products) || [],
			categories: (entity.category && entity.category.categories) || [],
			supplementCategories: entity.supplementCategory || [],
		},
		label,
		filename: `modifications-${toFileNameFragment(label) || 'export'}-${moment().format(
			'YYYY-MM-DD'
		)}.xlsx`,
	});
}

function* exportStashContent(action) {
	yield call(
		exportContent,
		'/stashContent',
		{ id_menu: action.id_menu, id: action.id },
		action.name,
		true
	);
}

function* exportPatchMenuContent(action) {
	yield call(
		exportContent,
		'/patchContent',
		action.id_company
			? {
					id_patch_menu: action.id_patch_menu,
					id_company: action.id_company,
			  }
			: { id_patch_menu: action.id_patch_menu },
		action.name
	);
}

///////////////////////////
//  DÉPLOIEMENT À VENIR   //
///////////////////////////
// Déplacer ou annuler un déploiement réécrit les lignes de draft_synchro : la
// carte du jour peut en sortir changée, d'où le rechargement complet plutôt
// qu'une simple relecture de la liste.
function* refreshAfterPatchChange() {
	yield call(fetchAll);
	yield put({ type: 'REFRESH_DAY_CHANGES' });
	yield call(fetchLastPatchMenus);
}

function* updatePatchDate(action) {
	const id_menu = yield call(getMenuSelected);
	const { result } = yield call(
		requestHandler,
		ENTITY,
		PATCH_METHOD,
		true,
		{ id_patch_menu: action.id_patch_menu, id_menu, date: action.date },
		'/patchDate'
	);

	if (result === false) {
		yield call(notifyError, 'deploy.history.dateFail');
		yield call(fetchLastPatchMenus);
		return;
	}

	// Le serveur répond skipped quand la date choisie est celle déjà en place :
	// rien n'a bougé, il n'y a rien à recharger ni à annoncer.
	if (result.result && result.result.skipped) {
		return;
	}

	yield call(refreshAfterPatchChange);
	yield put({
		type: ADD_NOTIFICATION,
		notification: {
			tags: [TAGS.SUCCESS],
			text: I18n.t('deploy.history.dateSuccess', {
				date: moment(action.date).format('DD/MM/YYYY'),
			}),
			date: moment().format('DD/MM/YYYY HH:mm'),
			viewed: false,
		},
	});
}

function* cancelPatch(action) {
	const id_menu = yield call(getMenuSelected);
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'DELETE',
		true,
		{ id_patch_menu: action.id_patch_menu, id_menu },
		'/patch'
	);

	if (result === false) {
		yield call(notifyError, 'patchMenu.deletePatchFail');
		yield call(fetchLastPatchMenus);
		return;
	}

	yield call(refreshAfterPatchChange);
	yield put({
		type: ADD_NOTIFICATION,
		notification: {
			tags: [TAGS.SUCCESS],
			text: I18n.t('patchMenu.deleteSuccess'),
			date: moment().format('DD/MM/YYYY HH:mm'),
			viewed: false,
		},
	});
}

////////////////////////////
//  RÉFÉRENCES DES FILS   //
////////////////////////////
function* analyseChildRefs(action) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/childRefs',
		{ id_company: action.id_company }
	);

	if (result === false) {
		yield call(notifyError, 'childRefs.analyseFail');
		yield put({ type: CHILD_REFS_SUCCESS, result: null });
		return;
	}

	yield put({ type: CHILD_REFS_SUCCESS, result: result.result || null });
}

function* importChildRefs(action) {
	const id_menu = yield call(getMenuSelected);
	const body = { id_company: action.id_company, id_menu };
	if (Array.isArray(action.entities) && action.entities.length) {
		body.entities = action.entities;
	}
	if (action.removed) {
		body.removed = true;
	}

	const { result } = yield call(
		requestHandler,
		ENTITY,
		POST_METHOD,
		true,
		body,
		'/childRefs'
	);

	if (result === false) {
		yield call(notifyError, 'childRefs.importFail');
		yield put({ type: CHILD_REFS_SUCCESS, result: null });
		return;
	}

	const payload = result.result || {};

	// La carte du siège a gagné des produits : elle est rechargée, et
	// l'analyse rejouée pour que l'écran reflète ce qu'il reste.
	yield call(fetchAll);
	yield call(analyseChildRefs, action);

	yield put({
		type: ADD_NOTIFICATION,
		notification: {
			tags: [TAGS.SUCCESS],
			text: I18n.t(
				payload.removed ? 'childRefs.importedRemoved' : 'childRefs.imported',
				{ count: payload.imported || 0 }
			),
			date: moment().format('DD/MM/YYYY HH:mm'),
			viewed: false,
		},
	});
}

export function* watchAnalyseChildRefs() {
	yield takeLatest(CHILD_REFS_ANALYSE, analyseChildRefs);
}

export function* watchImportChildRefs() {
	yield takeLatest(CHILD_REFS_IMPORT, importChildRefs);
}

////////////////////////////////////
//  SUPPRIMER (SITES) DEPUIS LE SIÈGE //
////////////////////////////////////
function* resetChildrenChanges(action) {
	const id_menu = yield call(getMenuSelected);
	const { result } = yield call(
		requestHandler,
		ENTITY,
		POST_METHOD,
		true,
		{ id_menu, ids_company: action.ids_company },
		'/reset-children'
	);

	if (result === false) {
		yield call(notifyError, 'childrenReset.fail');
		yield put({ type: CHILDREN_RESET_SUCCESS, results: null });
		return;
	}

	yield put({
		type: CHILDREN_RESET_SUCCESS,
		results: (result && result.result) || [],
	});
}

export function* watchResetChildrenChanges() {
	yield takeLatest(CHILDREN_RESET, resetChildrenChanges);
}

export function* watchUpdatePatchDate() {
	yield takeLatest(PATCH_DATE_UPDATE, updatePatchDate);
}

export function* watchCancelPatch() {
	yield takeLatest(PATCH_CANCEL, cancelPatch);
}

export function* watchExportStashContent() {
	yield takeEvery(STASH_CONTENT_EXPORT, exportStashContent);
}

export function* watchExportPatchMenuContent() {
	yield takeEvery(PATCH_MENU_CONTENT_EXPORT, exportPatchMenuContent);
}

export function* watchCreateStash() {
	yield takeLatest(STASH_CREATE, createStash);
}

export function* watchRestoreStash() {
	yield takeLatest(STASH_RESTORE, restoreStash);
}

export function* watchDeleteStash() {
	yield takeEvery(STASH_DELETE, deleteStash);
}

////////////
// RESET  //
////////////
export function* preResetPatchMenu() {
	while (true) {
		const action = yield take(PRE_RESET_PATCH_MENU);
		const { id_menu } = action.patch;

		yield put({
			type: PRE_REQUEST_RESET_PATCH_MENU,
			body: { id_menu },
		});

		yield take(REQUEST_RESET_PATCH_MENU_FINISHED);

		yield call(fetchAll);
		//
		yield put({ type: RESET_PATCH_MENU });
	}
}

export function* watchResetPatchMenu() {
	while (true) {
		const action = yield take(PRE_REQUEST_RESET_PATCH_MENU);
		yield call(
			requestHandler,
			ENTITY,
			PATCH_METHOD,
			true,
			action.body,
			'/reset-patchMenu',
			{
				id_menu: action.body.id_menu,
			}
		);

		yield put({
			type: ADD_NOTIFICATION,
			notification: {
				tags: [TAGS.SUCCESS],
				text: I18n.t('patchMenu.resetSuccess'),
				date: moment().format('DD/MM/YYYY HH:mm'),
				viewed: false,
			},
		});
		yield put({ type: REQUEST_RESET_PATCH_MENU_FINISHED });
	}
}

////////////
// DEPLOY //
////////////
export function* preDeployPatchMenu() {
	while (true) {
		const action = yield take(PRE_DEPLOY_PATCH_MENU);
		const { patchMenu, date } = action;
		const id_menu = action.patchMenu.id_menu;
		let length = 1;

		for (let i = 0; i < length; i++) {
			yield put({
				type: PRE_REQUEST_DEPLOY_PATCH_MENU,
				body: {
					...patchMenu,
					refresh_token: window.localStorage.refresh_token,
				},
				index: i,
				totalLength: length,
			});
		}

		const store = yield select();
		const result = yield take(REQUESTS_DEPLOY_PATCH_MENU_FINISHED);
		let children = result.response.idsCompanies.reduce((acc, id) => {
			let child = store.entity.children.find(c => c.id == id);
			if (child) acc.push(child);
			return acc;
		}, []);

		if (!result.response.patchEmpty && !result.response.updateFail) {
			let zone = store.entity.zone.find(
				z => z.id == window.sessionStorage.getItem('id_zone')
			);

			browserHistory.push({
				pathname: '/deployRecap',
				state: {
					patch: { name: patchMenu.name },
					children: children,
					isMaster: result.response.isMaster,
					id_menu: id_menu,
					nameRestaurant: getRestaurantName(store.entity.variable),
					nameMenu: patchMenu.nameMenu,
					date,
					lang: getServiceLang(store.entity.variableServer),
					zone: zone ? zone.name : null,
				},
			});
		}

		yield put({ type: DEPLOY_PATCH_MENU, response: result.response });
	}
}

export function* watchDeployPatchMenu() {
	while (true) {
		const action = yield take(PRE_REQUEST_DEPLOY_PATCH_MENU);
		const { result } = yield call(
			requestHandler,
			ENTITY,
			POST_METHOD,
			true,
			action.body,
			'/deploy'
		);

		if (result && result.result && result.result.patchEmpty) {
			yield put({
				type: ADD_NOTIFICATION,
				notification: {
					tags: [TAGS.ERROR],
					text: I18n.t('patchMenu.noModifications'),
					date: moment().format('DD/MM/YYYY HH:mm'),
					viewed: false,
				},
			});
		} else if (result && result.result && result.result.updateFail) {
			yield put({
				type: ADD_NOTIFICATION,
				notification: {
					tags: [TAGS.ERROR],
					text: I18n.t('patchMenu.updateFail'),
					date: moment().format('DD/MM/YYYY HH:mm'),
					viewed: false,
				},
			});
		} else if (result && result.result && result.result.deployFail) {
			yield put({
				type: ADD_NOTIFICATION,
				notification: {
					tags: [TAGS.ERROR],
					text: I18n.t('patchMenu.deployFail'),
					date: moment().format('DD/MM/YYYY HH:mm'),
					viewed: false,
				},
			});
		} else {
			yield put({
				type: ADD_NOTIFICATION,
				notification: {
					tags: [TAGS.SUCCESS],
					text: I18n.t('patchMenu.deploySuccess'),
					date: moment().format('DD/MM/YYYY HH:mm'),
					viewed: false,
				},
			});
		}
		yield put({
			type: REQUESTS_DEPLOY_PATCH_MENU_FINISHED,
			response: {
				idsCompanies: result && result.result ? result.result.idsCompanies : [],
				patchEmpty:
					result && result.result ? !!result.result.patchEmpty : false,
				updateFail:
					result && result.result ? !!result.result.updateFail : false,
			},
		});
	}
}

export function* resetChanges() {
	while (true) {
		const { id_menu } = yield take('PRE_RESET_CHANGES');

		const result = yield call(watchResetChanges, { id_menu });
		// Le serveur sauvegarde la carte avant de supprimer : s'il n'a pas pu,
		// rien n'a été supprimé, et il faut le dire.
		if (result === false) {
			yield call(notifyError, 'patchMenu.resetFail');
		}

		yield call(fetchAll);
	}
}

function* watchResetChanges(body) {
	const { result } = yield call(
		requestHandler,
		ENTITY,
		PATCH_METHOD,
		true,
		body,
		'/reset-patchMenu'
	);
	return result;
}

export function* resetChangesMaster() {
	while (true) {
		const { id_menu } = yield take('PRE_RESET_CHANGES_MASTER');

		yield call(watchResetChangesMaster, { id_menu });

		yield call(fetchAll);
	}
}

function* watchResetChangesMaster(body) {
	yield call(
		requestHandler,
		ENTITY,
		POST_METHOD,
		true,
		body,
		'/reset-to-master'
	);
}
